/* LUME custom: quick-add (replaces EA) + cart coupon field.
   Mirrors the theme's own add-to-cart flow (no page reload).
   Hardened (18/06/26): event delegation kills the inject-timing race that
   let early/re-render clicks fall through to the card link (= page refresh),
   plus user-facing error feedback + one network retry. */
(function () {
  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 7.5h12l-0.8 12.5H6.8L6 7.5Z"/><path d="M9 7.5a3 3 0 0 1 6 0"/></svg>';

  function getHandle(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function money(cents) {
    try { return '₪' + (cents / 100).toLocaleString('he-IL'); }
    catch (e) { return '₪' + Math.round(cents / 100); }
  }

  /* ---- transient-failure-tolerant fetch (retries network drops only) ---- */
  function fetchRetry(url, opts, retries) {
    return fetch(url, opts).catch(function (e) {
      if (retries > 0) {
        return new Promise(function (res) { setTimeout(res, 600); })
          .then(function () { return fetchRetry(url, opts, retries - 1); });
      }
      throw e;
    });
  }

  /* ---- toast feedback (so a failed add is never silent) ---- */
  function toast(msg, state) {
    var t = document.createElement('div');
    t.className = 'lume-toast' + (state ? ' lume-toast--' + state : '');
    t.setAttribute('role', 'status');
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-on'); });
    setTimeout(function () {
      t.classList.remove('is-on');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 300);
    }, 2800);
  }
  function errText(e) { return (e && e.message) ? e.message : 'ההוספה נכשלה, נסו שוב'; }

  function cartSectionEls() {
    return [document.querySelector('page-header'), document.querySelector('cart-drawer')].filter(Boolean);
  }
  function applySections(data) {
    if (!data || !data.sections) return;
    cartSectionEls().forEach(function (el) {
      var id = el.dataset.sectionId;
      if (id && data.sections[id] && typeof el.updateFromCartChange === 'function') {
        el.updateFromCartChange(data.sections[id]);
      }
    });
  }
  function refreshCartSections() {
    var ids = cartSectionEls().map(function (el) { return el.dataset.sectionId; });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ sections: ids.join(','), sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (data) { applySections(data); return data; });
  }

  function addVariant(variantId) {
    var sections = cartSectionEls();
    var ids = sections.map(function (el) { return el.dataset.sectionId; });
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', 1);
    fd.append('sections_url', window.location.pathname);
    fd.append('sections', ids.join(','));
    var addUrl = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
    return fetchRetry(addUrl, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    }, 1).then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, data: data }; });
    }).then(function (res) {
      if (!res.ok) throw new Error((res.data && res.data.description) || 'הפריט אזל מהמלאי');
      if (res.data.sections) applySections(res.data);
      else document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      // Quick-add intentionally mirrors the product page's "notification" flow
      // (update header count + gentle toast) and does NOT open the cart drawer.
      // Opening the drawer here triggers the theme's drawer refresh/merge path,
      // whose internal try/catch falls back to window.location.reload() — that
      // was the "added but the page reloads" bug. A toast is reload-free and
      // resilient on weak networks (a failure just shows an error toast).
      toast('הפריט נוסף לעגלה ✓');
      document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: res.data.variant_id } }));
    });
  }

  /* ---- inline variant chooser ---- */
  function onEsc(e) { if (e.key === 'Escape') closeChooser(); }
  function closeChooser() {
    var ov = document.querySelector('.lume-vc');
    if (ov && ov.parentNode) ov.parentNode.removeChild(ov);
    document.removeEventListener('keydown', onEsc);
  }
  function openChooser(product) {
    closeChooser();
    var opts = product.variants.map(function (v) {
      var dis = v.available ? '' : ' disabled';
      return '<button type="button" class="lume-vc__opt" data-id="' + v.id + '"' + dis + '>' +
             '<span>' + (v.title || '') + '</span><span class="lume-vc__price">' + money(v.price) + '</span></button>';
    }).join('');
    var ov = document.createElement('div');
    ov.className = 'lume-vc';
    ov.innerHTML =
      '<div class="lume-vc__backdrop"></div>' +
      '<div class="lume-vc__sheet" role="dialog" aria-modal="true">' +
        '<button type="button" class="lume-vc__close" aria-label="סגירה">&times;</button>' +
        '<div class="lume-vc__title">' + (product.title || '') + '</div>' +
        '<div class="lume-vc__sub">בחרו אפשרות</div>' +
        '<div class="lume-vc__opts">' + opts + '</div>' +
      '</div>';
    document.body.appendChild(ov);
    document.addEventListener('keydown', onEsc);
    ov.querySelector('.lume-vc__backdrop').addEventListener('click', closeChooser);
    ov.querySelector('.lume-vc__close').addEventListener('click', closeChooser);
    ov.querySelectorAll('.lume-vc__opt:not([disabled])').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.classList.contains('is-loading')) return;
        b.classList.add('is-loading');
        addVariant(b.getAttribute('data-id'))
          .then(function () { closeChooser(); })
          .catch(function (e) { console.error('LUME add:', e); b.classList.remove('is-loading'); toast(errText(e), 'error'); });
      });
    });
    requestAnimationFrame(function () { ov.classList.add('is-open'); });
  }

  function handleClick(handle, btn) {
    if (!handle || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    fetchRetry('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } }, 1)
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var variants = product.variants || [];
        if (variants.length <= 1) {
          var available = variants.filter(function (v) { return v.available; });
          var v = available[0] || variants[0];
          if (!v) throw new Error('הפריט אזל מהמלאי');
          return addVariant(v.id);
        }
        openChooser(product);
        return null;
      })
      .catch(function (e) { console.error('LUME quick-add:', e); toast(errText(e), 'error'); })
      .then(function () { btn.classList.remove('is-loading'); });
  }

  /* Delegated click handler (capture phase) — runs before the card link's
     default navigation, so quick-add clicks NEVER trigger a page load even if
     the per-card button was just re-rendered (filter/variant change). */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.lume-quick-add');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var card = btn.closest('.product-block');
    handleClick(card && getHandle(card), btn);
  }, true);

  function injectButtons() {
    var conts = document.querySelectorAll('.product-block .image-cont');
    for (var i = 0; i < conts.length; i++) {
      var cont = conts[i];
      if (cont.querySelector('.lume-quick-add')) continue;
      var card = cont.closest('.product-block');
      if (!card) continue;
      // Skip compact cards (Shop the look, predictive search, etc.) — no quick-add there;
      // clicking the product navigates to its page.
      if (card.classList.contains('product-block--compact')) continue;
      if (!getHandle(card)) continue;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lume-quick-add';
      btn.setAttribute('aria-label', 'הוספה לעגלה');
      btn.innerHTML = ICON;
      // No per-button listener — the delegated document handler above owns clicks.
      cont.appendChild(btn);
    }
  }

  /* ---- cart coupon code ---- */
  function setCouponMsg(text, state) {
    var msg = document.querySelector('[data-lume-coupon-msg]');
    if (!msg) return;
    msg.textContent = text || '';
    msg.className = 'lume-coupon__msg' + (state ? ' ' + state : '');
  }
  function codeMatches(cart, code) {
    var up = (code || '').toUpperCase();
    var apps = cart.discount_applications || [];
    if (apps.some(function (d) { return ((d.title || '') + '').toUpperCase() === up || ((d.code || '') + '').toUpperCase() === up; })) return true;
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      var ds = items[i].discounts || [];
      for (var j = 0; j < ds.length; j++) { if (((ds[j].title || '') + '').toUpperCase() === up) return true; }
      var la = items[i].line_level_discount_allocations || [];
      for (var k = 0; k < la.length; k++) {
        var da = la[k].discount_application;
        if (da && ((da.title || '') + '').toUpperCase() === up) return true;
      }
    }
    return false;
  }
  function applyCoupon(code) {
    code = (code || '').trim();
    if (!code) { setCouponMsg('הקלידו קוד', 'is-error'); return; }
    var wrap = document.querySelector('[data-lume-coupon]');
    if (wrap) wrap.classList.add('is-loading');
    setCouponMsg('מחיל...', '');
    var baseDiscount = 0;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (before) { baseDiscount = before.total_discount || 0; return fetch('/discount/' + encodeURIComponent(code), { method: 'GET' }); })
      .then(function () { return refreshCartSections(); })
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ok = (cart.total_discount || 0) > baseDiscount || codeMatches(cart, code);
        if (ok) setCouponMsg('הקוד הוחל בהצלחה ✓', 'is-ok');
        else setCouponMsg('קוד לא תקף או לא בתוקף', 'is-error');
      })
      .catch(function (e) { console.error('LUME coupon:', e); setCouponMsg('שגיאה, נסו שוב', 'is-error'); })
      .then(function () { if (wrap) wrap.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lume-coupon-btn]');
    if (!btn) return;
    e.preventDefault();
    var input = document.querySelector('[data-lume-coupon-input]');
    applyCoupon(input && input.value);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (e.target && e.target.matches && e.target.matches('[data-lume-coupon-input]')) {
      e.preventDefault();
      applyCoupon(e.target.value);
    }
  });

  /* ---- init ---- */
  if (document.readyState !== 'loading') injectButtons();
  else document.addEventListener('DOMContentLoaded', injectButtons);

  var t;
  if (window.MutationObserver) {
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(injectButtons, 150); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
})();
